<template>
  <div id="hj-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-section">
      <div class="container">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/pc/mall' }">商城首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ category.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!-- 分类头部 -->
    <div class="category-header-section">
      <div class="container">
        <div class="category-info">
          <h1>{{ category.name }}</h1>
          <!-- <p class="category-desc">{{ category.description }}</p> -->
          <div class="category-stats">
            <!-- 共找到 <span class="highlight">{{ total }}</span> 件商品 -->
          </div>
        </div>
      </div>
    </div>

    <!-- 筛选和排序 -->
    <!-- <div class="filter-section">
      <div class="container"> -->
        <!-- <commonSearch @search="handleSearch" :inputValue="searchKeyword" :showQuickSearch="false" /> -->
        <!-- <div class="filter-row">
          <span class="filter-label">品牌:</span>
          <div class="filter-options">
            <span :class="['filter-option', selectedBrand === '' ? 'active' : '']" @click="selectBrand('')">全部</span>
            <span v-for="brand in brands" :key="brand.id" :class="['filter-option', selectedBrand === brand.id ? 'active' : '']" @click="selectBrand(brand.id)">
              {{ brand.name }}
            </span>
          </div>
        </div> -->

        <!-- <div class="filter-row">
          <span class="filter-label">价格:</span>
          <div class="filter-options">
            <span :class="['filter-option', selectedPriceRange === '' ? 'active' : '']" @click="selectPriceRange('')">不限</span>
            <span :class="['filter-option', selectedPriceRange === '0-10' ? 'active' : '']" @click="selectPriceRange('0-10')">10元以下</span>
            <span :class="['filter-option', selectedPriceRange === '10-50' ? 'active' : '']" @click="selectPriceRange('10-50')">10-50元</span>
            <span :class="['filter-option', selectedPriceRange === '50-100' ? 'active' : '']" @click="selectPriceRange('50-100')">50-100元</span>
            <span :class="['filter-option', selectedPriceRange === '100+' ? 'active' : '']" @click="selectPriceRange('100+')">100元以上</span>
          </div>
        </div> -->

        <!-- <div class="filter-row">
          <span class="filter-label">排序:</span>
          <div class="filter-options">
            <span :class="['filter-option', sortBy === 'default' ? 'active' : '']" @click="sortBy = 'default'">默认排序</span>
            <span :class="['filter-option', sortBy === 'sales' ? 'active' : '']" @click="sortBy = 'sales'">销量优先</span>
            <span :class="['filter-option', sortBy === 'price-asc' ? 'active' : '']" @click="sortBy = 'price-asc'">价格升序</span>
            <span :class="['filter-option', sortBy === 'price-desc' ? 'active' : '']" @click="sortBy = 'price-desc'">价格降序</span>
            <span :class="['filter-option', sortBy === 'rating' ? 'active' : '']" @click="sortBy = 'rating'">评分优先</span>
          </div>
        </div> -->
      <!-- </div>
    </div> -->

    <!-- 商品展示 -->
    <div class="products-section">
      <div class="container">
        <div class="products-grid">
          <product-card v-for="product in products" :key="product.id" :product="product" @click="goToProduct(product.id)" />
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
          <el-pagination background layout="prev, pager, next, jumper" :total="total" :page-size="pageSize" :current-page="currentPage" @current-change="handlePageChange"> </el-pagination>
        </div>
      </div>
    </div>

    <footer-layout></footer-layout>
  </div>
</template>

<script>
import FooterLayout from '@/components/pc/FooterLayout.vue'
import commonSearch from './components/commonSearch.vue'
import ProductCard from './components/ProductCard.vue'
import mall from '@/api/mall'
export default {
  name: 'MallCategory',
  components: { FooterLayout, commonSearch, ProductCard },
  data() {
    return {
      searchKeyword: '',
      selectedBrand: '',
      selectedPriceRange: '',
      sortBy: 'default',
      currentPage: 1,
      pageSize: 24,
      total: 0,
      category: {
        id: 1,
        name: '医用耗材'
      },
      brands: [
        { id: 1, name: '强生' },
        { id: 2, name: '3M' },
        { id: 3, name: '拜耳' },
        { id: 4, name: '罗氏' },
        { id: 5, name: '迈瑞' }
      ],
      products: []
    }
  },
  methods: {
    // handleSearch(keyword) {
    //   this.searchKeyword = keyword
    //   this.getPartProductList(this.categoryId)
    // },
    //获取【分类广场商品列表】
    getPartProductList(id) {
      const params = {
        frontCateId: id, //前端类目ID
        pageNumber: this.currentPage, //页码
        pageSize: this.pageSize, //页大小
        channelCode: this.$local.get('channelCode'),
        productName: this.searchKeyword || ''
      }
      mall.getProductCategoryList(params).then((res) => {
        this.products = res.data.data
      })
    },
    handlePageChange(page) {
      this.currentPage = page
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goToProduct(productId) {
      this.$router.push(`/pc/mall/product/${productId}`)
    }
  },
  mounted() {
    // 根据路由参数获取分类信息
    this.category.id = this.$route.params.categoryId
    this.category.name = this.$route.params.categoryName
    //获取【分类广场商品列表】
    this.getPartProductList(this.category.id)
    // 这里可以调用API获取分类详情和商品列表
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  // padding: 0 20px;
}

.breadcrumb-section {
  background: #f8f9fa;
  padding: 10px 0;

  ::v-deep .el-breadcrumb {
    font-size: 14px;

    .el-breadcrumb__item__inner {
      color: #666;

      &:hover {
        color: #409eff;
      }
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #409eff;
    }
  }
}

.category-header-section {
  background: white;
  padding: 20px 0;
  border-bottom: 1px solid #e5e5e5;

  .category-info {
    h1 {
      font-size: 28px;
      color: #333;
      margin: 0 0 10px 0;
      font-weight: bold;
      text-align: left;
    }

    .category-desc {
      color: #666;
      font-size: 16px;
      margin-bottom: 15px;
    }

    .category-stats {
      color: #666;

      .highlight {
        color: #409eff;
        font-weight: bold;
      }
    }
  }
}

.filter-section {
  margin: 0 140px;
  background: white;
  border-bottom: 1px solid #e5e5e5;
  padding: 20px 0;

  .filter-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    .filter-label {
      color: #333;
      font-weight: bold;
      width: 80px;
      flex-shrink: 0;
    }

    .filter-options {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .filter-option {
        padding: 5px 15px;
        margin-right: 10px;
        margin-bottom: 5px;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: all 0.3s;

        &:hover {
          border-color: #409eff;
          color: #409eff;
        }

        &.active {
          background: #409eff;
          color: white;
          border-color: #409eff;
        }
      }
    }
  }
}

.products-section {
  padding: 30px 0;
  min-height: 600px;

  .products-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 20px;
    margin-bottom: 40px;

    .product-card {
      background: white;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
      }

      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
      }

      .product-info {
        padding: 15px;

        h4 {
          font-size: 16px;
          margin: 0 0 10px 0;
          color: #333;
          height: 44px;
          overflow: hidden;
          line-height: 22px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .product-price {
          color: #e74c3c;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 8px;
        }

        .product-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;

          .product-sales {
            color: #999;
            font-size: 12px;
          }

          .product-rating {
            i {
              font-size: 12px;

              &.el-icon-star-on {
                color: #ffa500;
              }

              &.el-icon-star-off {
                color: #ddd;
              }
            }
          }
        }

        .product-shop {
          color: #666;
          font-size: 12px;
        }
      }
    }
  }

  .pagination-section {
    text-align: center;

    ::v-deep .el-pagination {
      .el-pager li.active {
        background-color: #409eff;
        color: white;
      }
    }
  }
}
</style>
